/**
 * !html5-adplayer-skin v1.6.3 / 2021-01-20 / INVIDI Pulse Ad Player Base Skin TODO MOVE TO OUR ADPLAYER
 */
;(function () {
	var PulseAdPlayerSkin = function (adPlayer) {
		var PlayButton = function (div, adPlayer) {
			this._parent = div
			this._adPlayer = adPlayer
			this._button = document.createElement('div')
			this._button.className = 'pulse-play-button'
			this._button.style.pointerEvents = 'all'
			this.hide()

			this._parent.appendChild(this._button)

			this._onClick = function () {
				this._adPlayer.play()
			}.bind(this)
		}

		PlayButton.prototype = {
			show: function () {
				this._button.style.display = 'block'
				this._button.addEventListener('click', this._onClick)
			},
			hide: function () {
				this._button.style.display = 'none'
				this._button.removeEventListener('click', this._onClick)
			},
		}

		var SkipButton = function (div, adPlayer) {
			this._parent = div
			this._adPlayer = adPlayer
			this._button = document.createElement('pulse-skip-button')
			this._button.className = 'pulse-btn pulse-skip-button pulse-hide'
			this._button.innerHTML = SKIN_STRINGS.SKIP_AD
			this._parent.appendChild(this._button)

			this._onClick = function () {
				this._adPlayer.skipButtonClicked()
			}.bind(this)
		}

		SkipButton.prototype = {
			show: function () {
				this._button.className = 'pulse-btn pulse-skip-button focus pulse-show'
				this._button.addEventListener('click', this._onClick)
				this._button.style.pointerEvents = 'all'
			},
			hide: function () {
				this._button.className = 'pulse-btn pulse-skip-button pulse-hide'
				this._button.removeEventListener('click', this._onClick)
				this._button.style.pointerEvents = 'none'
			},
		}

		var SkipCountdown = function (div, adPlayer) {
			this._parent = div
			this._adPlayer = adPlayer
			this._label = document.createElement('span')
			this._label.className = 'pulse-btn pulse-skip-countdown pulse-hide'
			this._parent.appendChild(this._label)
			this._ad = null
		}

		SkipCountdown.prototype = {
			show: function () {
				if (!this._ad) {
					return
				}

				this._label.className = 'pulse-btn pulse-skip-countdown pulse-show'
			},
			hide: function () {
				if (!this._ad) {
					return
				}

				this._label.className = 'pulse-btn pulse-skip-countdown pulse-hide'
			},

			setAd: function (ad) {
				this._ad = ad
				this.update(0)
			},

			update: function (position) {
				if (!this._ad) {
					return
				}

				var remaining = Math.ceil(this._ad.getSkipOffset() - position)
				var template = SkipCountdown.getStringTemplate(remaining)

				if (template) {
					this.show()

					this._label.innerHTML = template.replace('[countdown]', remaining)
				} else {
					this.hide()
				}
			},
		}

		var AdCounter = function (div, adPlayer) {
			this._parent = div
			this._adPlayer = adPlayer
			this._label = document.createElement('pulse-ad-counter')
			this._label.className = 'pulse-btn pulse-ad-counter'
			this._parent.appendChild(this._label)
			this._adBreak = null
		}

		AdCounter.prototype = {
			show: function () {
				this._label.className = 'pulse-btn pulse-ad-counter pulse-show'
			},
			hide: function () {
				this._label.className = 'pulse-btn pulse-ad-counter pulse-hide'
			},
			setAdBreak: function (adBreak) {
				this._adBreak = adBreak
				this.update()
			},
			update: function () {
				var position = this._adBreak.getPlayableAdsTotal() - this._adBreak.getPlayableAdsRemaining() + 1
				this._label.innerHTML = SKIN_STRINGS.AD_COUNTER.replace('[position]', position).replace(
					'[total]',
					this._adBreak.getPlayableAdsTotal()
				)
			},
		}

		var AdEndCounter = function (div, adPlayer) {
			this._parent = div
			this._adPlayer = adPlayer
			this._label = document.createElement('pulse-ad-counter')
			this._label.className = 'pulse-btn-small pulse-ad-end-counter'
			this._parent.appendChild(this._label)
			this._adEndCount = null
		}

		AdEndCounter.prototype = {
			show: function () {
				this._label.className = 'pulse-btn-small pulse-ad-end-counter pulse-show'
			},
			hide: function () {
				this._label.className = 'pulse-btn-small pulse-ad-end-counter pulse-hide'
			},
			setAdEndCount: function (countdown) {
				this._adEndCount = countdown
				this.update()
			},
			update: function () {
				const formattedTime = secondsToMinutesAndSeconds(this._adEndCount)
				var position = this._adEndCount
				this._label.innerHTML = SKIN_STRINGS.AD_END_COUNTER.replace('[countdown]', formattedTime)
			},
		}

		SkipCountdown.getStringTemplate = function (seconds) {
			if (seconds === 1) {
				return SKIN_STRINGS.SKIP_COUNTDOWN_SINGULAR
			} else if (seconds === 2) {
				return SKIN_STRINGS.SKIP_COUNTDOWN_DUAL
			} else if (seconds > 2) {
				return SKIN_STRINGS.SKIP_COUNTDOWN_PLURAL
			}

			return null
		}

		var ProgressBar = function (div, adPlayer) {
			this._parent = div
			this._adPlayer = adPlayer
			this._progress = document.createElement('progress')
			this._progress.className = 'pulse-progress pulse-progress-hide'
			this._progress.min = 0
			this._progress.max = 1
			this._progress.value = 0
			this.hide()
			div.appendChild(this._progress)
		}

		ProgressBar.prototype = {
			show: function () {
				this._progress.className = 'pulse-progress pulse-progress-show'
			},
			hide: function () {
				this._progress.className = 'pulse-progress pulse-progress-hide'
			},
			setProgress: function (progress) {
				this._progress.value = progress
			},
		}
		var MuteButton = function (div, adPlayer, isMuted) {
			this._mutedClassNames = 'pulse-skin-button pulse-mute-button-muted'
			this._unmutedClassNames = 'pulse-skin-button pulse-mute-button-unmuted'

			this._parent = div
			this._adPlayer = adPlayer

			// container
			this._container = document.createElement('div')
			this._container.className = 'pulse-skin-button-container-top'

			// aspect ratio-maintaining dummy
			this._dummy = document.createElement('div')
			this._dummy.className = 'pulse-skin-button-ar'

			// actual button
			this._button = document.createElement('div')
			this._button.addEventListener('click', this.click.bind(this))
			this.hide()

			this._container.appendChild(this._dummy)
			this._container.appendChild(this._button)
			div.appendChild(this._container)

			// reverted in click()
			this._muted = isMuted
			if (this._adPlayer.getVolume) {
				this._button.className = this._adPlayer.getVolume() ? this._unmutedClassNames : this._mutedClassNames
			} else {
				this.click()
			}
		}

		MuteButton.prototype = {
			click: function () {
				if (this._adPlayer.getVolume) {
					this._muted = this._adPlayer.getVolume() === 0
				}

				if (this._muted) {
					this.unmute()
				} else {
					this.mute()
				}
			},

			mute: function () {
				if (this._adPlayer.mute) {
					this._adPlayer.mute()
					this._button.className = this._adPlayer.getVolume() ? this._unmutedClassNames : this._mutedClassNames
				} else {
					this._button.className = this._mutedClassNames
					this._adPlayer.setVolume(0)
				}
				this._muted = true
			},

			unmute: function () {
				if (this._adPlayer.unmute) {
					this._adPlayer.unmute()
					this._button.className = this._adPlayer.getVolume() ? this._unmutedClassNames : this._mutedClassNames
				} else {
					this._button.className = this._unmutedClassNames
					this._adPlayer.setVolume(1)
				}
				this._muted = false
			},

			show: function () {
				this._button.style.display = 'block'
				if (this._adPlayer.getVolume()) {
					this._button.className = this._adPlayer.getVolume() ? this._unmutedClassNames : this._mutedClassNames
				}
			},

			hide: function () {
				this._button.style.display = 'none'
			},

			onVolumeChanged: function (volume) {
				this._button.className = volume ? this._unmutedClassNames : this._mutedClassNames
			},
		}
		var CloseButton = function (div, adPlayer, onclick) {
			this._parent = div
			this._adPlayer = adPlayer

			// container
			this._container = document.createElement('div')
			this._container.className = 'pulse-skin-button-container-top'

			// aspect ratio-maintaining dummy
			this._dummy = document.createElement('div')
			this._dummy.className = 'pulse-skin-button-ar'

			// actual button
			this._onclick = onclick
			this._button = document.createElement('div')
			this._button.className = 'pulse-skin-button pulse-close-button'
			this.hide()

			this._container.appendChild(this._dummy)
			this._container.appendChild(this._button)
			div.appendChild(this._container)
		}

		CloseButton.prototype = {
			show: function () {
				this._button.style.display = 'block'
				this._button.addEventListener('click', this._onclick)
			},

			hide: function () {
				this._button.style.display = 'none'
				this._button.removeEventListener('click', this._onclick)
			},
		}

		function removeClassFromElement(element, className) {
			var replacementRegex = new RegExp('( ' + className + ')', 'g')
			element.className.replace(replacementRegex, '')
		}

		function isNumber(n) {
			return !isNaN(parseFloat(n)) && isFinite(n)
		}

		function secondsToMinutesAndSeconds(seconds) {
			const minutes = Math.floor(seconds / 60)
			const remainingSeconds = seconds % 60

			const formattedMinutes = String(minutes).padStart(2, '0')
			const formattedSeconds = String(remainingSeconds).padStart(2, '0')

			return `${formattedMinutes}:${formattedSeconds}`
		}

		var SKIN_STRINGS = {
			SKIP_AD: 'Skip Ad',

			SKIP_COUNTDOWN_SINGULAR: 'Skip Ad in [countdown]',
			SKIP_COUNTDOWN_DUAL: 'Skip Ad in [countdown]',
			SKIP_COUNTDOWN_PLURAL: 'Skip Ad in [countdown]',

			AD_COUNTER: 'Ad [position] of [total]',
			AD_END_COUNTER: 'Ad - [countdown]',
		}

		var SKIN_EVENTS = [
			OO.Pulse.AdPlayer.Events.LINEAR_AD_PAUSED,
			OO.Pulse.AdPlayer.Events.LINEAR_AD_PLAYING,
			OO.Pulse.AdPlayer.Events.AD_BREAK_STARTED,
			OO.Pulse.AdPlayer.Events.AD_BREAK_FINISHED,
			OO.Pulse.AdPlayer.Events.LINEAR_AD_STARTED,
			OO.Pulse.AdPlayer.Events.LINEAR_AD_FINISHED,
			OO.Pulse.AdPlayer.Events.SHOW_SKIP_BUTTON,
			OO.Pulse.AdPlayer.Events.LINEAR_AD_SKIPPED,
			OO.Pulse.AdPlayer.Events.LINEAR_AD_PROGRESS,
			OO.Pulse.AdPlayer.Events.AD_VOLUME_CHANGED,
			OO.Pulse.AdPlayer.Events.AD_AUTOPLAY_BLOCKED,
			OO.Pulse.AdPlayer.Events.PAUSE_AD_SHOWN,
			OO.Pulse.AdPlayer.Events.OVERLAY_AD_SHOWN,
			OO.Pulse.AdPlayer.Events.PAUSE_AD_PLAYER_HIDDEN,
		]

		var onPlayerEvent = function (event, eventData) {
			switch (event) {
				case OO.Pulse.AdPlayer.Events.AD_BREAK_STARTED:
					this.setControls(['loadingSpinner '])
					this._controls.adCounter.setAdBreak(eventData.adBreak)
					break
				case OO.Pulse.AdPlayer.Events.AD_BREAK_FINISHED:
					this.setControls()
					break
				case OO.Pulse.AdPlayer.Events.LINEAR_AD_STARTED:
					var linearAdStartedControls = [
						//'adCounter',
						//'progressBar',
						//'adEndCounter',
					]
					this._isPlayingVPAID = false
					var selectedMediaFile = eventData.ad.getMediaFiles()[0]
					if (selectedMediaFile.apiFramework && selectedMediaFile.apiFramework === 'VPAID') {
						this._isPlayingVPAID = true
					}
					OO.Pulse.Utils.log('Skin: Selected media file is a ' + (this._isPlayingVPAID ? 'VPAID ad' : 'video ad'))

					this._adPlayer.resize(
						OO.Pulse.AdPlayer.Settings.SCALING.AUTO,
						OO.Pulse.AdPlayer.Settings.SCALING.AUTO,
						this._isFullscreen
					)
					setTimeout(
						function () {
							this._adPlayer.resize(
								OO.Pulse.AdPlayer.Settings.SCALING.AUTO,
								OO.Pulse.AdPlayer.Settings.SCALING.AUTO,
								this._isFullscreen
							)
						}.bind(this),
						100
					)

					if (!this._isPlayingVPAID) {
						this._controls.skipCountdown.setAd(eventData.ad)
						if (eventData.ad.isSkippable() && eventData.ad.getSkipOffset() === 0) {
							linearAdStartedControls.push('skipButton')
						}
					}

					this.setControls(linearAdStartedControls)
					this._controls.adCounter.update()
					break
				case OO.Pulse.AdPlayer.Events.LINEAR_AD_FINISHED:
				case OO.Pulse.AdPlayer.Events.LINEAR_AD_SKIPPED:
					this.setControls(['loadingSpinner'])
					this._controls.skipCountdown.setAd(null)
					break
				case OO.Pulse.AdPlayer.Events.LINEAR_AD_PROGRESS:
					this._controls.progressBar.setProgress(eventData.position / eventData.duration)
					this._controls.adEndCounter.setAdEndCount(Math.round(eventData.duration - eventData.position))
					if (!this._isPlayingVPAID) {
						this._controls.skipCountdown.update(eventData.position)
					}
					break
				case OO.Pulse.AdPlayer.Events.LINEAR_AD_PAUSED:
					if (!this._isPlayingVPAID) {
						this.setControls([
							// 'adCounter',
							//'progressBar',
							'playButton',
							//'adEndCounter',
						])
					} else {
						this.setControls([
							// 'adCounter',
							//'progressBar',
							//'adEndCounter',
						])
					}
					break
				case OO.Pulse.AdPlayer.Events.LINEAR_AD_PLAYING:
					this.setControls([
						//'adCounter',
						//'progressBar',
						//'adEndCounter',
					])
					break
				case OO.Pulse.AdPlayer.Events.SHOW_SKIP_BUTTON:
					if (this._isPlayingVPAID) {
						this.setControls([
							// 'adCounter',
							//'progressBar',
							'skipButton',
							//'adEndCounter',
						])
					} else {
						this.setControls([
							// 'adCounter',
							//'progressBar',
							'skipButton',
							//'adEndCounter',
						])
					}
					break
				case OO.Pulse.AdPlayer.Events.AD_VOLUME_CHANGED:
					this._controls.muteButton.onVolumeChanged(eventData.volume)
					break
				case OO.Pulse.AdPlayer.Events.AD_AUTOPLAY_BLOCKED:
					this.setControls(['playButton'])
					OO.Pulse.Utils.log('Skin: Hiding the loading screen as blocked autoplay was detected')
					break
				case OO.Pulse.AdPlayer.Events.PAUSE_AD_SHOWN:
					this.setControls(['pauseAdCloseButton'])
					break
				case OO.Pulse.AdPlayer.Events.OVERLAY_AD_SHOWN:
					this.setControls(['overlayCloseButton'])
					break
				case OO.Pulse.AdPlayer.Events.PAUSE_AD_PLAYER_HIDDEN:
					this.setControls()
					break
				default:
					break
			}
		}.bind(this)

		this.setControls = function (enabledControls) {
			// Hide everything
			for (var control in this._controls) {
				this._controls[control].hide()
			}

			// Show selected controls
			if (enabledControls) {
				for (var i = 0; i < enabledControls.length; ++i) {
					var controlIndex = enabledControls[i]

					if (this._controls[controlIndex]) {
						this._controls[controlIndex].show()
					}
				}
			}
		}.bind(this)

		var addPlayerEventListeners = function (adPlayer) {
			for (var i in SKIN_EVENTS) {
				adPlayer.addEventListener(SKIN_EVENTS[i], onPlayerEvent)
			}
		}

		var addFullScreenListeners = function () {
			document.addEventListener(
				'webkitfullscreenchange',
				function () {
					this._isFullscreen = document.webkitIsFullScreen
					this._adPlayer.resize(
						OO.Pulse.AdPlayer.Settings.SCALING.AUTO,
						OO.Pulse.AdPlayer.Settings.SCALING.AUTO,
						this._isFullscreen
					)
				}.bind(this)
			)

			document.addEventListener(
				'mozfullscreenchange',
				function () {
					this._isFullscreen = document.mozFullScreen
					this._adPlayer.resize(
						OO.Pulse.AdPlayer.Settings.SCALING.AUTO,
						OO.Pulse.AdPlayer.Settings.SCALING.AUTO,
						this._isFullscreen
					)
				}.bind(this)
			)

			document.addEventListener(
				'fullscreenchange',
				function () {
					this._isFullscreen = document.fullscreen
					this._adPlayer.resize(
						OO.Pulse.AdPlayer.Settings.SCALING.AUTO,
						OO.Pulse.AdPlayer.Settings.SCALING.AUTO,
						this._isFullscreen
					)
				}.bind(this)
			)

			document.addEventListener(
				'msfullscreenchange',
				function () {
					this._isFullscreen = document.msFullscreenElement
					this._adPlayer.resize(
						OO.Pulse.AdPlayer.Settings.SCALING.AUTO,
						OO.Pulse.AdPlayer.Settings.SCALING.AUTO,
						this._isFullscreen
					)
				}.bind(this)
			)
		}.bind(this)

		var skinDiv = adPlayer.getSkinElement()
		var overlayDiv = adPlayer.getOverlayDiv()
		skinDiv.className = 'pulse-adplayer-skin'

		this._isPlayingVPAID = false
		this._isFullscreen = false
		this._adPlayer = adPlayer

		this._controls = {
			playButton: new PlayButton(skinDiv, adPlayer, this),
			skipButton: new SkipButton(skinDiv, adPlayer),
			progressBar: new ProgressBar(skinDiv, adPlayer),
			skipCountdown: new SkipCountdown(skinDiv, adPlayer),
			adCounter: new AdCounter(skinDiv, adPlayer),
			adEndCounter: new AdEndCounter(skinDiv, adPlayer),
			muteButton: new MuteButton(skinDiv, adPlayer, false),
			overlayCloseButton: new CloseButton(
				overlayDiv,
				adPlayer,
				function () {
					this._adPlayer.overlayAdClosed()
					this._controls.overlayCloseButton.hide()
				}.bind(this)
			),

			pauseAdCloseButton: new CloseButton(
				skinDiv,
				adPlayer,
				function () {
					this._controls.pauseAdCloseButton.hide()
					this._adPlayer.pauseAdClosed()
				}.bind(this)
			),
		}

		addPlayerEventListeners(adPlayer)
		addFullScreenListeners()
	}

	try {
		if (OO && OO.Pulse) {
			OO.Pulse.adPlayerReady(function (adPlayer) {
				var skin = new PulseAdPlayerSkin(adPlayer)
			})
		} else {
			throw new Error('The Pulse SDK is not ready. Make sure to include the skin script _after_ the SDK script.')
		}
	} catch (error) {
		console.error('An error occurred:', error.message)
	}
})()
